// extracted by css-extract-rspack-plugin
export default {"image":"_45ac14c8"};